import { iframeResizer } from "iframe-resizer";
import { LOADING_HTML_SNIPPET } from "./constants";
import { IMessageData, ILoadIframeOptions } from "./types";

export const handleIframeOnLoad =
    (loadingSpinner: HTMLDivElement, iframe: HTMLIFrameElement) => () => {
        loadingSpinner.setAttribute("style", "display:none;");
        iframe.setAttribute("style", "");
        postMessage(iframe);
    };

export const loadResizer = (iframeId: string) => {
    iframeResizer(
        { log: process.env.NODE_ENV === "development", inPageLinks: true, resizeFrom: "child" },
        `#${iframeId}`
    );
};

export const loadIframe = ({
    src,
    iframeAndContainerIds: { containerId, iframeId },
}: ILoadIframeOptions) => {
    const container = document.getElementById(containerId);
    if (!container) return;
    const loadingSpinner = document.createElement("div");
    loadingSpinner.setAttribute("style", "height: 100%");
    loadingSpinner.innerHTML = LOADING_HTML_SNIPPET;
    container.appendChild(loadingSpinner);
    const iframe = document.createElement("iframe");
    iframe.setAttribute("style", "display:none;");
    iframe.setAttribute("id", iframeId);
    iframe.setAttribute("src", src);
    iframe.setAttribute("class", "tiretutor-iframe");
    iframe.onload = handleIframeOnLoad(loadingSpinner, iframe);
    container.appendChild(iframe);
    loadResizer(iframeId);
};

export const isTtIntegrationMessage = (message: MessageEvent) =>
    message.data.startsWith("[ttIntegration]");

export const parseMessage = (message: MessageEvent): IMessageData =>
    JSON.parse(message.data.replace("[ttIntegration]", ""));

export const postMessage = (iframe: HTMLIFrameElement) => {
    const iframeBaseUrl = new URL(iframe.src).origin;
    const trackProps = localStorage.getItem("tt-track");
    let rsAnonId = null;
    if (window.rudderanalytics) {
        rsAnonId = window.rudderanalytics.getAnonymousId();
    }
    if (rsAnonId && trackProps) {
        const trackPropsParsed = JSON.parse(trackProps);
        const payload = {
            // eslint-disable-next-line camelcase
            track_props: trackPropsParsed,
            // eslint-disable-next-line camelcase
            rs_anon_id: rsAnonId,
            from: "TT-Dealer",
        };

        iframe.contentWindow.postMessage(payload, iframeBaseUrl);
    }
};
